var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',_vm._b({attrs:{"type":"info","size":_vm.$store.state.buttonSize},on:{"click":_vm.handleClick}},'el-button',_vm.$attrs,false),[_vm._v("批量删除")])}
var staticRenderFns = []

export { render, staticRenderFns }